export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.client) return;

  // Need to load user location on the server side
  useUserLocation();
});
